import { UntypedFormControl, ValidatorFn, Validators } from '@angular/forms';
import moment from 'moment';

import { FieldValidation } from '../models';

export function FieldValidationsFactory(validation: FieldValidation): ValidatorFn {
  switch (validation.type) {
    case 'NON_ZERO':
      const minValue = validation.value.replace(/[^\d.]/g, '');
      let minValueNumeric = Number(minValue);
      if (isNaN(minValueNumeric)) {
        minValueNumeric = 0.01;
      }
      return Validators.min(minValueNumeric);
    case 'NON_FUTURE_DATE':
      return (dateCtrl: UntypedFormControl) => {
        if (!dateCtrl?.value) {
          return null;
        }
        const today = moment.utc().endOf('day');
        const selectedDate = moment.utc(dateCtrl?.value);
        return today.isBefore(selectedDate) ? { noFutureDate: true } : null;
      };

    default:
      return null;
  }
}
